import React from 'react'
import '../../styles/sass/_About.css'
import { Col, Carousel } from 'react-bootstrap'
// import first from '../../img/aboutme/slider/camel.jpg'
// import second from '../../img/aboutme/slider/dessert.jpg'
// import third from '../../img/aboutme/slider/group2.jpg'
// import fourth from '../../img/aboutme/slider/group1.jpg'
// import fifth from "../../img/aboutme/slider/camp.jpg";
import first from '../../img/aboutme/slider/camel2.jpg'
import second from '../../img/aboutme/slider/second2.png'
import third from '../../img/aboutme/slider/third.png'
import fourth from '../../img/aboutme/slider/fourth.png'
import fifth from '../../img/aboutme/slider/camp2.png'

const CarouselPics = () => {
  return (
    <div>
      <Col lg={5} md={5} lgOffset={1} mdOffset={1} xsHidden smHidden className='pics-slider'>
        <Carousel>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={first} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={second} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={third} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={fourth} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={fifth} />
          </Carousel.Item>
        </Carousel>
      </Col>
      <Col smOffset={3} xsOffset={3} xs={6} sm={6} lgHidden mdHidden className='pics-slider__cel'>
        <Carousel>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={first} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={second} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={third} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={fourth} />
          </Carousel.Item>
          <Carousel.Item>
            <img width={400} height={300} alt='400x300' src={fifth} />
          </Carousel.Item>
        </Carousel>
      </Col>
    </div>
  )
}

export default CarouselPics



// WEBPACK FOOTER //
// ./src/components/About/Slider.js